<template>
  <v-container class="d-flex align-center justify-center fill-height" style="min-height: 100vh;">
    <!-- Solo mostrar el formulario de login si el usuario no está logueado -->
    <v-card v-if="!isLoggedIn" class="pa-4" elevation="3" width="100%" max-width="280" color="blue-grey-lighten-5">
      <v-card-title class="justify-center">
        <h3>Inicio de Sesión</h3>
      </v-card-title>
      <v-card-text>
        <v-form>
          <v-text-field
            :ref="'username'"
            v-model="username"
            v-bind="form.username"
            prepend-inner-icon="mdi-account-hard-hat"
            @keydown="userName($event)">
          </v-text-field>
          <v-text-field
            :ref="'password'"
            v-model="password"
            v-bind="form.password"
            prepend-inner-icon="mdi-lock"
            @keydown="passwordInput($event)">
          </v-text-field>
          <v-combobox
            :ref="'proyecto'"
            v-model="proyecto"
            v-bind="form.proyecto"
            :items="form.proyecto.items"
            @keydown.enter="iniciarSesion"/>
          <v-btn
            block
            class="white--text"
            color="yellow darken-3"
            @click="iniciarSesion">
            Iniciar Sesión
          </v-btn>
        </v-form>
        <v-alert
          dense
          outlined
          class="mt-4"
          v-if="mensaje"
          :type="mensajeType">
          {{ mensaje }}
        </v-alert>
      </v-card-text>
    </v-card>
    <!-- Si ya está logueado, el formulario no se muestra y el usuario es redirigido automáticamente -->
    <router-view />
    <PreguntaDialog ref="preguntaDialog" />
  </v-container>
</template>

  
  <script>
  import PreguntaDialog from '@/components/PreguntaDialog.vue'
  import axios from "axios";
  
  export default {
    data() {
      return {
        token: "",
        proyecto: "AEROVICHADA",
        proyect: {
          "AEROVICHADA": 'AEROV',
          "BAHIA SOLANO": 'BAHIA',
        },
        username: "",
        password: "",
        mensaje: "",
        mensajeType: "info", // 'info', 'success', 'error', etc.
        form: {
          username: {
            id: "username:",
            label: "Usuario:",
            variant: 'outlined',
            density: "compact",
            clearable: true,
            required: true,
          },
          password: {
            id: "password:",
            label: "Contraseña:",
            type: "password",
            variant: 'outlined',
            density: "compact",
            clearable: true,
            required: true,
          },
          proyecto: {
            id: "proyecto",
            label: "Proyecto",
            variant: 'outlined',
            density: 'compact',
            required: true,
            // disabled: true,
            items: ['AEROVICHADA', 'BAHIA SOLANO',]
          },
        },
      };
    },
    components:{
      PreguntaDialog,
    },
    computed: {
      // Verifica si el usuario está logueado
      isLoggedIn() {
        return localStorage.getItem("usuario_logueado") !== null;
      },
    },
    mounted() {
      // Si el usuario ya está logueado, redirige a la página principal
      if (this.isLoggedIn) {
        this.$router.push("/main");
      } else {
        this.$nextTick(() => {
          this.$refs.username.focus(); // Focaliza el input después de que el DOM se monte completamente
        });
      }
    },
    methods: {
      async iniciarSesion() {
        // const proyect = {
        //   "AEROVICHADA": 'AEROV',
        //   "BAHIA SOLANO": 'BAHIA',
        // }
        try {
          const response = await axios.post(
            "https://aerovichada.com.co/AEROV/api.php",
            {
              username: this.username,
              password: this.password,
              proyecto: this.proyect[this.proyecto],
            }
          );
          // return;
          if (response.data.status === "success") {
            this.mensaje = response.data.message;
            this.mensajeType = "success";
            // Guardar en localStorage y redirigir
            // localStorage.setItem("usuario_logueado", this.username);
            localStorage.setItem("user_acces", JSON.stringify(response.data));
            const userData = JSON.parse(localStorage.getItem("user_acces"));
            userData.proyecto = this.proyect[this.proyecto];
            localStorage.setItem("user_acces", JSON.stringify(userData));
            this.$router.push("/main");
            // console.log("Inicio de sesión exitoso");
          } else {
            if (response.data.status == "sesion_activa") {
              this.mensaje = response.data.message;
              this.mensajeType = "error";
              this.token = response.data.token;
              localStorage.setItem("user_acces", JSON.stringify(response.data));
              this.$refs.preguntaDialog.abrir("¿Iniciar nueva Sesion?", this.cerrrarSesion);
            } else {
              this.mensaje = response.data.message;
              this.mensajeType = "error";
            }
          }
        } catch (error) {
          console.error("Detalles del error:", error.response || error.message);
          this.mensaje = "Error al conectar con el servidor";
          this.mensajeType = "error";
        }
      },
      async cerrrarSesion(param) {
        if (param == "si") {
          try {
            const response = await axios.put("https://aerovichada.com.co/AEROV/crear_sesion.php", {proyecto: localStorage.getItem("proyecto") || this.proyect[this.proyecto]}, { headers: { Authorization: `Bearer ${this.token}`} });
            if (response.data.status == "success") {
              return this.iniciarSesion();
            } else {
              // window.location.reload();
            }
          } catch (error) {
            console.log('error :>> ', error);
          }
        }else{
          this.$nextTick(()=>{
            this.$refs.password.focus();
          })
        }
      },
      userName(event) {
        const key = event.key.toLowerCase();
        if (key === "enter") {
          this.$refs.password.focus();
        }
      },
      passwordInput(event) {
        const key = event.key.toLowerCase();
        if (key === "escape") {
          this.$refs.username.focus();
        } else if (key === "enter") {
          this.iniciarSesion();
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .v-card {
    border-radius: 12px;
  }
  </style>
  